export const localeEN = {
  lang: 'en',
  data: {
    NAV: {
      APPLICATIONS: 'Applications',
      SAMPLE: {
        TITLE: 'Voorbeeld',
        BADGE: '222',
      },
    },
  },
}



// WEBPACK FOOTER //
// ./src/app/navigation/i18n/en.ts